var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-results"},[_c('div',{staticClass:"no-results__image"},[_vm._t("image")],2),_vm._t("text",function(){return [_c('div',{staticClass:"no-results__text"},[_vm._v(" "+_vm._s(_vm.localization("app-no-results-found", "No results found"))+" ")])]}),_c('div',{staticClass:"no-results__button"},[_vm._t("button")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }